import { Media } from '../../media';

export type NewMessage = {
  message: string;
  media?: Media[];
};
